import { Link } from 'react-router-dom';
import { ShieldAlert, FileQuestion, ArrowLeft } from 'lucide-react';

export default function ErrorPage({ type = '404' }) {
  const is403 = type === '403';

  const title = is403 ? 'Adgang nægtet (403)' : 'Siden blev ikke fundet (404)';
  const description = is403
    ? 'Du har ikke tilladelse til at se denne side. Kontakt venligst administratoren, hvis du mener, dette er en fejl.'
    : 'Beklager, men den side du leder efter findes ikke eller er blevet flyttet.';

  return (
    <div className="flex min-h-[70vh] flex-col items-center justify-center bg-white px-4 text-center">
      <div className="rounded-2xl bg-navy-50 p-6 text-navy-900 mb-6">
        {is403 ? (
          <ShieldAlert className="h-16 w-16 text-red-600" />
        ) : (
          <FileQuestion className="h-16 w-16 text-energy-600" />
        )}
      </div>
      <h1 className="text-3xl font-extrabold text-navy-950 sm:text-4xl md:text-5xl">
        {title}
      </h1>
      <p className="mx-auto mt-4 max-w-md text-base text-graphite-600 leading-relaxed">
        {description}
      </p>
      <div className="mt-10">
        <Link
          to="/"
          className="inline-flex items-center gap-2 rounded-xl bg-energy-600 px-6 py-3 text-sm font-semibold text-white shadow-md transition-all duration-200 hover:bg-energy-700 hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-energy-500"
        >
          <ArrowLeft className="h-4 w-4" />
          Tilbage til forsiden
        </Link>
      </div>
    </div>
  );
}
